import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import CancellationPolicyService from '../../api/services/CancellationPolicyService';
import MainPagetitle from '../../layouts/MainPagetitle';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import { Modal, Button } from 'react-bootstrap';

const EditCancellationPolicy = () => {
  const navigate = useNavigate();
  var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL + 'Policy/';
  const params = useParams();
  const [blogModal, setBlogModal] = useState(false);
  const [cancellationpolicy, setCancellationPolicy] = useState([]);
  const [file, setFile] = useState()
  const [error, setError] = useState([]);
  const [isLoading, setisloading] = useState(true);
  const [fields, setFields] = useState([{ i_title: '' }])
  const [defields, setdeFields] = useState([{ i_title: '' }])
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      var id = params.id;
      getCancellationPolicyByID(id);
    }
    else {
      navigate('/')
    }
  }, []);
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }

  const getCancellationPolicyByID = async (id) => {
    try {
      let voucherList = await CancellationPolicyService.show(id).json();
      setCancellationPolicy(voucherList.data);
      setisloading(false);
      const item_list = voucherList.data.item_list.map((element) => {
        return element
      })
      setFields(item_list)
      const de_item_list = voucherList.data.de_item_list.map((element) => {
        return element
      })
      setdeFields(de_item_list)
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };


  let addFormFields = () => {
    setFields([...fields, '']);
  }
  let removeFormFields = (i) => {
    let values = [...fields];
    values.splice(i, 1);
    setFields(values)
  }
  let addGermanFormFields = () => {
    setdeFields([...defields, { i_title: '' }]);
  }
  let removeGermanFormFields = (i) => {
    let values = [...defields];
    values.splice(i, 1);
    setdeFields(values)
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      const items = []
      const deitems =[]
      Object.keys(fields).forEach(key => items.push(fields[key]))
      Object.keys(defields).forEach(key => deitems.push(defields[key]))
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "price": event.target.price.value,
        // 'item_list': items,
        // 'de_item_list': deitems,
        "icon": file ? file.split(',')[1] : "",
      }
      console.log(userData)
      let responseData = await CancellationPolicyService.update(params.id, userData).json()
      if (responseData.status === true) {
        navigate("/admin/cancellation-policy");
      }
    } catch (error) {

      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message)
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Edit Cancellation Policy" pageTitle={'Edit Cancellation Policy'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Edit Cancellation Policy</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          cancellationpolicy.title
                            ? cancellationpolicy.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username"
                        defaultValue={cancellationpolicy.de_title? cancellationpolicy.de_title: ''} 
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" >Price<span className="text-danger">*</span></label>
                     
                        
                         <input type="number" className="form-control" name='price' min={0} defaultValue={ cancellationpolicy
                            ? cancellationpolicy.price
                            : ''} />
                    </div>
                    {/* <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">English Item<span className="text-danger">*</span></label>

                      {fields.map((element, index) => {
                        return (

                          <div key={index}>

                            <input type="text" className="form-control mt-2" name="i_title"
                              onChange={(e) => {
                                const updatedFields = [...fields];
                                updatedFields[index] = e.target.value;
                                setFields(updatedFields);
                              }}
                              value={element}
                              defaultValue={element}
                            />
                            {
                              index ?
                                <button type="button" className="button remove mt-3 p-2" onClick={() => removeFormFields(index)}>Remove English Item</button>
                                : null
                            }

                          </div>
                        );
                      })}

                      < button className="button add mt-3 p-2 " type="button" onClick={addFormFields} > Add English Item</button>

                    </div> */}
                    {/* <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">German Item<span className="text-danger">*</span></label>
                      {defields.map((element, index) => {
                        return (
                          <div>
                            <input type="text" className="form-control mt-2" name="de_i_title"
                              onChange={(e) => {
                                const updatedFields = [...defields];
                                updatedFields[index] = e.target.value;
                                setdeFields(updatedFields);
                              }}
                              value={element}
                              defaultValue={element}
                            />
                            {
                              index ?
                                <button type="button" className="button remove mt-3 p-2" onClick={() => removeGermanFormFields(index)}>Remove German Item</button>
                                : null
                            } 
                          </div>
                         );
                      })} 
                      < button className="button add mt-3 p-2 " type="button"  onClick={addGermanFormFields}> Add German Item</button>
                    </div> */}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={100} width={100} name="icon" src={file ? file : imageUrl + cancellationpolicy.icon} alt='' />
                      <input type="file" className="form-control" name='icon' onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={blogModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setBlogModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Voucher Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/vouchers'} variant="danger light" onClick={() => setBlogModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditCancellationPolicy;